module.exports = __webpack_public_path__ + "static/media/paso 6.93c4909d.png";